import type { FC, ReactNode } from "react";
import { ChevronRight } from "lucide-react";

import { cn } from "@/shared/utils/core";

interface OptionCardProps {
  icon: FC<{ className?: string }>;
  iconBg: string;
  iconColor: string;
  title: string;
  subtitle: string;
  onClick: () => void;
  disabled?: boolean;
  footer?: ReactNode;
}

export const OptionCard: FC<OptionCardProps> = ({
  icon: Icon,
  iconBg,
  iconColor,
  title,
  subtitle,
  onClick,
  disabled,
  footer,
}) => (
  <button
    type="button"
    className={cn(
      "flex w-full gap-6 rounded-lg border border-primary bg-white p-6 text-left transition-colors hover:bg-subtle disabled:opacity-50",
      footer ? "items-start" : "items-center",
    )}
    onClick={onClick}
    disabled={disabled}
  >
    <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-sm ${iconBg}`}>
      <Icon className={`h-5 w-5 ${iconColor}`} />
    </div>
    <div className="min-w-0 flex-1">
      <p className="font-medium">{title}</p>
      <p className="text-sm text-secondary">{subtitle}</p>
      {footer}
    </div>
    <ChevronRight className="h-5 w-5 shrink-0 text-tertiary" />
  </button>
);
